import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorSSOPageComponent } from './module/error-sso/error-sso.component';
import { ExpiredComponent } from './module/expired/expired.component';
import { LoginPageComponent } from './module/login-page/login-page.component';
import { PasswordPageComponent } from './module/password-page/password-page.component';
import { PasswordResetPageComponent } from './module/password-reset-page/password-reset-page.component';


const appRoutes: Routes = [
    { path: '', component: LoginPageComponent },
    { path: 'expired', component: ExpiredComponent },
    { path: 'setup-password/:resetPasswordKey', component: PasswordResetPageComponent, data: { setup: true } },
    { path: 'request-password', component: PasswordPageComponent },
    { path: 'reset-password', component: PasswordResetPageComponent },
    { path: 'reset-password/:resetPasswordKey', component: PasswordResetPageComponent },
    { path: 'error', component: ErrorSSOPageComponent },
    { path: '**', redirectTo: '' },
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {}),
    ],
    exports: [
        RouterModule,
    ],
})
export class LoginAppRouterModule { }